export default {
    isAvailable: !!window.showDirectoryPicker,

    async getDirPermissions(dirHandle) {
        if (dirHandle == null) return null; //Backup setting not enabled.
        var permission = await dirHandle.queryPermission({mode: 'readwrite'});
        if (permission != 'granted') { // 'prompt' or 'denied'
            permission = await dirHandle.requestPermission({mode: 'readwrite'});
        }
        return permission;
    },

    async saveToFile(dirHandle, fileName, header, rows) {
        if (dirHandle == null) return;
        var fileHandle = await this.getFileHandle(dirHandle, fileName);
        var writableStream = await fileHandle.createWritable();
        await writableStream.write(header);
        await writableStream.write("\r\n");
        var data = rows.join("\r\n");
        await writableStream.write(data);
        await writableStream.close();
    },

    async getNewFileName(dirHandle, name) {
        var version = 0;
        var fileName = null;
        do {
            fileName = `${name}_${version}.txt`;
            try {
                await dirHandle.getFileHandle(fileName, { create: false });
            }
            catch (error) {
                if (error.name == "NotFoundError") break;
                throw error;
            }
            version += 1;
        } while (version < 100);

        if (version == 100) throw new Error("File Creation error. Too many versions of " + name);
        return fileName;
    },

    async getFileHandle(dirHandle, fileName) {
        var handle = null;
        try {
            handle = await dirHandle.getFileHandle(fileName, { create: false });
        }
        catch (error) {
            if (error.name != "NotFoundError") throw error;
            handle = await dirHandle.getFileHandle(fileName, { create: true });
        }

        return handle;
    },
}